import React, { HTMLAttributes } from 'react'
import { Skeleton } from '@material-ui/lab'

import { TemplateItemSkeleton } from 'containers/PulseSurveys/TemplateItem/skeleton'

import * as S from './../list.styles'

export const ListSkeleton = (props: HTMLAttributes<HTMLElement>) => {
    return (
        <S.ListWrapper {...props}>
            <S.Header>
                <S.Title>
                    <Skeleton width={120} />
                </S.Title>
            </S.Header>

            <S.List>
                {new Array(4).fill('').map((_, index) => (
                    <TemplateItemSkeleton key={index} />
                ))}
            </S.List>
        </S.ListWrapper>
    )
}
